import { render } from "./DeletePropertie.vue?vue&type=template&id=5989f991"
import script from "./DeletePropertie.vue?vue&type=script&lang=js"
export * from "./DeletePropertie.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__